import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ResetPassword() {
  const query = useQuery();
  const navigate = useNavigate();
  const email = query.get('email') || '';
  const token = query.get('token') || '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setMsg('');
    if (!newPassword || !confirmPassword) {
      setError('Please fill in all fields.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch('https://server.oracy.uk/server/registration/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token, newPassword }),
      });
      const payload = await res.json();
      if (!res.ok) throw new Error(payload.message || 'Reset failed');
      setMsg(payload.message || 'Password has been reset successfully.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-orange-100 py-16 px-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-10 sm:p-12 flex flex-col items-center">
        <img src="/Logodark.svg" alt="Oracy Logo" className="h-20 w-20 mb-3" />
        <h2 className="text-3xl font-extrabold text-theme-orange mb-2 tracking-tight">Reset Password</h2>
        <form onSubmit={handleSubmit} className="w-full mt-2">
          {error && <div className="mb-4 text-red-600 text-sm text-center font-medium">{error}</div>}
          {msg && <div className="mb-4 text-green-600 text-sm text-center font-medium">{msg}</div>}
          <div className="mb-6">
            <label className="block mb-2 text-base font-medium text-gray-700">New Password</label>
            <input
              type="password"
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-500 transition text-base"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              required
              placeholder="Enter new password"
              disabled={submitting}
            />
          </div>
          <div className="mb-8">
            <label className="block mb-2 text-base font-medium text-gray-700">Confirm Password</label>
            <input
              type="password"
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-500 transition text-base"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              required
              placeholder="Confirm new password"
              disabled={submitting}
            />
          </div>
          <button
            type="submit"
            className="w-full bg-orange-600 text-white py-3 rounded-lg font-semibold text-lg shadow hover:bg-orange-700 transition disabled:opacity-60 mb-2"
            disabled={submitting}
          >
            {submitting ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
} 